module.exports = "/_next/static/images/3c35eed7a25a94b200f192a9e10159fa-credit-card-hero-lg-1x.jpg.webp";